import { Card, CardContent, Stack } from '@mui/material';
import React from 'react';
import { PrimaryLoadingButton } from '../style/ButtonStyle';
import { FormLabelText } from '../style/TextStyle';
import { CenterModal } from './Modal';

export function OkModal({
  on,
  title = '',
  loading = false,
  confirmText = '확인',
  children = <></>,
  onClose,
}: {
  on: boolean;
  title?: string | React.ReactNode;
  loading?: boolean;
  confirmText?: string | React.ReactNode;
  children?: string | React.ReactNode;
  onClose: any;
}) {
  return (
    <>
      <CenterModal open={on} onClose={onClose}>
        <Card sx={{ minWidth: '300px' }}>
          <CardContent>
            <Stack spacing={3}>
              <Stack alignItems="center">
                <FormLabelText sx={{ fontWeight: 700 }}>{title}</FormLabelText>
              </Stack>
              <Stack alignItems="center">{children}</Stack>
              <Stack direction="row" justifyContent="center" spacing={1}>
                <PrimaryLoadingButton
                  loading={loading || false}
                  onClick={onClose}
                >
                  {confirmText}
                </PrimaryLoadingButton>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </CenterModal>
    </>
  );
}
